var GateTypeKind = /* @__PURE__ */ ((GateTypeKind2) => {
  GateTypeKind2["Approval"] = "Approval";
  GateTypeKind2["Timed"] = "Timed";
  return GateTypeKind2;
})(GateTypeKind || {});
var GateTypeApprovalWorkflow = /* @__PURE__ */ ((GateTypeApprovalWorkflow2) => {
  GateTypeApprovalWorkflow2["External"] = "External";
  GateTypeApprovalWorkflow2["SelfAttestation"] = "SelfAttestation";
  GateTypeApprovalWorkflow2["BatchRequest"] = "BatchRequest";
  return GateTypeApprovalWorkflow2;
})(GateTypeApprovalWorkflow || {});
var GateState = /* @__PURE__ */ ((GateState2) => {
  GateState2["Active"] = "Active";
  GateState2["Waiting"] = "Waiting";
  GateState2["Approved"] = "Approved";
  GateState2["Rejected"] = "Rejected";
  return GateState2;
})(GateState || {});
var GateInfoScope = /* @__PURE__ */ ((GateInfoScope2) => {
  GateInfoScope2["Unknown"] = "Unknown";
  GateInfoScope2["ExperimentStep"] = "ExperimentStep";
  GateInfoScope2["Experiment"] = "Experiment";
  GateInfoScope2["Progression"] = "Progression";
  return GateInfoScope2;
})(GateInfoScope || {});
const isGateTypeApproval = (gateType) => !!gateType && gateType.kind === "Approval";
const isGateTypeTimed = (gateType) => !!gateType && gateType.kind === "Timed";
export {
  GateInfoScope,
  GateState,
  GateTypeApprovalWorkflow,
  GateTypeKind,
  isGateTypeApproval,
  isGateTypeTimed
};
//# sourceMappingURL=Gate.model.js.map
